import React, { useState } from 'react';
import { TextField, Typography } from '@material-ui/core';
import { validateHeight } from '../../util/validation';
import { useValidationWarningStyles } from '../../util/styles';

const HeightOverride = ({ overrideChange, currentValue, columnKey }) => {
  const classes = useValidationWarningStyles();
  const [warning, setWarning] = useState(validateHeight(currentValue));

  const handleChange = e => {
    const value = e.target.value;
    overrideChange(columnKey, value);
    setWarning(validateHeight(value));
  };

  return (
    <div>
      <TextField
        type="number"
        label="Height (cm)"
        value={currentValue || ''}
        onChange={handleChange}
        inputProps={{
          step: 1,
          min: 0,
        }}
      />
      {warning && <Typography className={classes.warningText}>{warning}</Typography>}
    </div>
  );
};

export { HeightOverride };
